import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';

type MatchRow = {
  csv_name: string;
  csv_website: string;
  company_id: number;
  company_name: string;
  company_website: string;
  company_uuid: string | null;
};

type UnmatchedRow = { csv_name: string; csv_website: string };

type MatchCompaniesType = {
  matches: MatchRow[];
  unmatched: UnmatchedRow[];
};

const postMatchCompanies = (
  rowsToMatch: {
    name: string;
    website: string;
  }[],
): Promise<AxiosResponse<MatchCompaniesType>> => {
  return api.post('/match-companies-by-urls/', { rows: rowsToMatch });
};

const getCompanyContactsPage = (
  id: string,
  page: number = 1,
): Promise<AxiosResponse<any>> => {
  return api.get(`/v3/companies/${id}/contacts/page/${page}/`);
};

const getCompanyInvolvement = (id: string): Promise<AxiosResponse<any>> => {
  return api.get(`/v3/companies/${id}/works-with/`);
};

const getCompaniesInvolvedInProject = (
  projectId: string,
): Promise<AxiosResponse<any>> => {
  return api.get(`/project/${projectId}/companies/`);
};

const getCompanyProjectCityCounts = (id: string): Promise<AxiosResponse<any>> => {
  return api.get(`/companies/${id}/projects/city/count/`);
};

export default {
  postMatchCompanies,
  getCompanyContactsPage,
  getCompanyInvolvement,
  getCompaniesInvolvedInProject,
  getCompanyProjectCityCounts,
};
